module.exports = __webpack_public_path__ + "img/index-purple.fc32828a.svg";